var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"PayPal","append-to-body":"","visible":_vm.visible,"width":_vm.isPC ? '30%' : '100%',"destroy-on-close":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.dialogCloseCb}},[_c('div',{attrs:{"id":"paypal-button-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }